/* The masthead (index.html's static .hero, now a component). The hamburger's
   aria-expanded tracks the drawer, and the ASI logo — a base64 data URI that
   used to live inline in index.html — moved here verbatim (CF10 big-bang) so
   the <body> is just the React mount point. Same DOM classes as styles.css.
   It also carries "Report a problem or idea", so the form is on every page
   (issue-tracker.md IT9). */
import type { JSX } from "react";
import { useAppState } from "./store";
import { ASI_LOGO_DATA_URI } from "./logo";
import { ReportIssue, ReportIssueButton } from "./ReportIssue";

export function Hero(): JSX.Element {
  const { state, store } = useAppState();
  /* the page behind the picker is inert while it is up (aria-modal's promise,
     app.ts behindPicker) — the hero is one of the two regions it covers */
  return (
    <>
      <div className="hero" inert={state.pickerOpen || undefined}>
        <div className="hero-inner">
          <button
            id="menu-btn"
            className="menu-btn"
            aria-label="Menu"
            aria-expanded={state.menuOpen}
            aria-controls="drawer"
            onClick={() => store.toggleMenu()}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
          <img
            src={ASI_LOGO_DATA_URI}
            alt="ASI — Autonomous Solutions, Inc."
            style={{ height: "26px", width: "auto", display: "block" }}
          />
          <h1>Hermes</h1>
          <div className="sub">Living project record</div>
          <ReportIssueButton />
        </div>
      </div>
      {/* outside .hero, so the drawer is neither clipped nor made inert with it */}
      <ReportIssue />
    </>
  );
}
